import AccessTokenApiRepository from './AccessTokenApiRepository';
import AccessTokenLocalRepository from './AccessTokenLocalRepository';

export default class AccessTokenService {
  tokenApi: AccessTokenApiRepository;
  tokenLocal: AccessTokenLocalRepository;

  constructor() {
    this.tokenApi = new AccessTokenApiRepository();
    this.tokenLocal = new AccessTokenLocalRepository();
  }

  get = () => {
    return this.tokenLocal.get();
  };

  set = (token: string): void => {
    this.tokenApi.set(token);

    if (import.meta.env.DEV) {
      this.tokenLocal.set(token);
    }
  };

  delete = () => {
    this.tokenApi.delete();

    if (import.meta.env.DEV) {
      this.tokenLocal.remove();
    }
  };
}
